// Duits (de-DE), homeApp: zelfde vorm als homeApp.nl.ts (golf 6b). Du-Form wie app.de.ts. Das
// Wetterdetail nennt nie Gebet oder Moschee (neutral).
export const appHomeDe = {
    customize: 'Anpassen',
    customizeLabel: 'Heute anpassen',
    done: 'Fertig',
    intro: 'Stell auf Heute, was dir wichtig ist. Zieh eine Karte an eine andere Stelle, mach sie am Rand oder an der Ecke größer oder kleiner, oder wähle S, M oder L.',
    /** Telefoon: alleen de volgorde (feat/vandaag-raster). */
    introList: 'Bring die Karten in die Reihenfolge, die du möchtest: Zieh am Griff oder nutze die Pfeile. Auf einem größeren Bildschirm kannst du sie auch frei platzieren und größer oder kleiner machen.',
    undo: 'Rückgängig',
    undone: 'Die letzte Änderung wurde rückgängig gemacht.',
    /** Raster (computer en tablet): zoals de bord-editor. */
    gridHint: 'Raster von Heute: Zieh eine Karte an eine andere Stelle, zieh am Rand oder an der Ecke, um sie kleiner oder größer zu machen.',
    cardAt: '{name}, {w} mal {h} Felder, Spalte {x}, Zeile {y}',
    keysHint: 'Pfeiltasten: verschieben. Umschalt und Pfeiltasten: kleiner oder größer.',
    noRoom: 'Passt hier nicht. Mach zuerst etwas kleiner oder entferne etwas.',
    size: 'Größe',
    sizes: { S: 'Klein', M: 'Mittel', L: 'Groß' },
    fitMore: '+{count} weitere',
    fitMoreAll: 'Mehr ansehen',
    reset: 'Standard wiederherstellen',
    resetDone: 'Heute sieht wieder aus wie vorher.',
    saveFailed: 'Speichern hat nicht geklappt. Versuch es gleich noch einmal.',
    add: 'Karte hinzufügen',
    addTitle: 'Karte hinzufügen',
    addNothing: 'Alle Karten sind schon da.',
    moveUp: '{name} nach oben',
    moveDown: '{name} nach unten',
    remove: '{name} entfernen',
    removed: '{name} wurde entfernt.',
    added: '{name} ist jetzt auf Heute.',
    drag: '{name} ziehen',
    position: '{name} ist jetzt auf Platz {pos} von {count}.',
    empty: 'Heute ist noch leer.',
    emptyBody: 'Tippe auf Anpassen und wähle, was du hier sehen willst.',
    emptyEdit: 'Noch keine Karten. Füge unten eine hinzu.',
    quiet: 'Gerade nichts zu sehen. Die Karte erscheint von selbst, sobald es etwas gibt.',
    widgets: {
        now: { name: 'Läuft gerade', description: 'Was gerade läuft oder gleich beginnt' },
        agenda: { name: 'Kalender heute', description: 'Alle Termine von heute' },
        tasks: { name: 'Aufgaben heute', description: 'Wie weit alle mit ihren Aufgaben sind' },
        tomorrow: { name: 'Morgen', description: 'Ein Blick auf die Termine von morgen' },
        weather: { name: 'Wetter', description: 'Wetter und Kleidungstipps, tippen für mehr' },
        rides: { name: 'Fahrten', description: 'Fahrten, für die noch niemand fährt' },
        prayer: { name: 'Gebetszeiten', description: 'Die Zeiten von heute' },
        check_in: { name: 'Täglicher Check-in', description: "Ob heute 'Alles gut' kam" },
        goals: { name: 'Sparen', description: 'Wie weit die Kinder mit dem Sparen sind' },
        shopping: { name: 'Einkäufe', description: 'Was noch besorgt werden muss' },
        messages: { name: 'Nachrichten', description: 'Neue Nachrichten aus der Familie' },
        wishes: { name: 'Wünsche', description: 'Die Wünsche der Kinder' },
        rotation: { name: 'Putzplan', description: 'Wer diese Woche was macht und wer heute kocht' },
        // Golf 8 (0049): Samen wonen.
        dinner: { name: 'Heute Abend essen', description: 'Wer mitisst und deine Wahl' },
        bookings: { name: 'Reservieren', description: 'Deine nächste Reservierung und was frei ist' },
        balance: { name: 'Kosten', description: 'Nur dein eigener Saldo' },
        // 0069: Geldzaken (alleen in je eigen omgeving).
        money: { name: 'Geldsachen', description: 'Was diesen Monat übrig blieb (nur du)' },
        todos: { name: 'To-dos', description: 'Deine offenen To-dos, mit Spätestens-Datum' },
        // 0076: schoolplanner.
        school: {
            name: 'Hausaufgaben und Arbeiten',
            description: 'Hausaufgaben von heute, kommende Arbeiten und Noten zum Eintragen',
        },
        // 0075: Huisronde (module Eten).
        house_round: {
            name: 'Hausrundgang',
            description: 'Der nächste Rundgang durchs Haus, und starten',
        },
    },
    shopping: {
        open: { one: '{count} Sache zu besorgen', other: '{count} Sachen zu besorgen' },
        empty: 'Alles ist besorgt.',
        all: 'Zu den Einkäufen',
        more: '+{count} weitere',
    },
    messages: {
        unread: { one: '{count} neue Nachricht', other: '{count} neue Nachrichten' },
        none: 'Keine neuen Nachrichten.',
        all: 'Zu den Nachrichten',
        voice: 'Sprachnachricht',
        sticker: 'Sticker',
        pictos: 'Bilder',
    },
    wishes: {
        count: { one: '{count} Wunsch', other: '{count} Wünsche' },
        empty: 'Noch keine Wünsche.',
        all: 'Zu den Wünschen',
    },
    /** Golf 6b fixer r1: widget Beurtrooster (huisgenoten). */
    rotation: {
        you: 'Du diese Woche',
        done: 'Erledigt',
        open: 'Noch offen',
        noneForYou: 'Diese Woche bist du nicht dran.',
        cooks: '{name} kocht heute',
        youCook: 'Du kochst heute',
        others: 'Der Rest des Hauses',
        all: 'Zum Putzplan',
        empty: 'Noch kein Putzplan.',
    },
    prayer: {
        next: 'Als Nächstes',
        settings: 'Einstellungen',
        fromTable: 'Aus dem Plan deiner Moschee',
    },
};
export const appAgendaViewsDe = {
    day: 'Tag',
    workweek: 'Arbeitswoche',
    week: 'Woche',
    month: 'Monat',
    workweekTitle: 'Arbeitswoche {week} · {range}',
    emptyWorkweek: 'Diese Arbeitswoche ist noch nichts geplant',
    prev: {
        day: 'Vorheriger Tag',
        workweek: 'Vorherige Arbeitswoche',
        week: 'Vorherige Woche',
        month: 'Vorheriger Monat',
    },
    next: {
        day: 'Nächster Tag',
        workweek: 'Nächste Arbeitswoche',
        week: 'Nächste Woche',
        month: 'Nächster Monat',
    },
    keys: 'Tastenkürzel: ← und → zum Blättern, T für heute.',
};
export const appWeatherDetailDe = {
    open: 'Mehr zum Wetter',
    titleToday: 'Das Wetter heute',
    titleTomorrow: 'Das Wetter morgen',
    today: 'Heute',
    tomorrow: 'Morgen',
    temp: 'Temperatur',
    tempRange: '{min}° bis {max}°',
    feels: 'Gefühlte Temperatur',
    feelsRange: '{min}° bis {max}°',
    feelsDay: 'tagsüber etwa {value}°',
    rain: 'Regen',
    rainChance: {
        dry: 'Trocken',
        small: 'Geringe Schauerwahrscheinlichkeit',
        likely: 'Regen möglich',
        wet: 'Regnerisch',
    },
    rainAmount: '{mm} mm',
    rainHours: { one: 'in {count} Stunde', other: 'in {count} Stunden' },
    rainWhen: 'zwischen {from} und {until}',
    rainPct: '{pct} % Wahrscheinlichkeit',
    rainNoPct: 'Für die Niederlande gibt MET Norway keine Wahrscheinlichkeit in Prozent an. Das ist die Menge, die laut Vorhersage fällt.',
    wind: 'Wind',
    windForce: 'Windstärke {bft}',
    windFrom: 'aus {dir}',
    windSpeed: '{kmh} km/h',
    bft: [
        'Windstille',
        'leiser Zug',
        'leichte Brise',
        'schwache Brise',
        'mäßige Brise',
        'frische Brise',
        'starker Wind',
        'steifer Wind',
        'stürmischer Wind',
        'Sturm',
        'schwerer Sturm',
        'orkanartiger Sturm',
        'Orkan',
    ],
    dirs: {
        N: 'Nord',
        NE: 'Nordost',
        E: 'Ost',
        SE: 'Südost',
        S: 'Süd',
        SW: 'Südwest',
        W: 'West',
        NW: 'Nordwest',
    },
    dirShort: { N: 'N', NE: 'NO', E: 'O', SE: 'SO', S: 'S', SW: 'SW', W: 'W', NW: 'NW' },
    uv: 'UV-Index',
    uvLevels: {
        low: 'niedrig',
        moderate: 'mäßig',
        high: 'hoch',
        very_high: 'sehr hoch',
        extreme: 'extrem',
    },
    uvValue: 'UV {value}, {level}',
    uvClearSky: 'bei klarem Himmel',
    sun: 'Sonne',
    sunrise: 'Aufgang {time}',
    sunset: 'Untergang {time}',
    course: 'Verlauf des Tages',
    courseOpen: 'Stunde für Stunde',
    back: 'Zurück',
    courseTemp: 'Temperatur (°C)',
    courseRain: 'Niederschlag (mm pro Stunde)',
    courseHour: '{time}: {temp}°, {rain} mm, Windstärke {bft}',
    partial: 'Noch sind nicht alle Stunden dieses Tages bekannt.',
    now: 'Jetzt',
    close: 'Schließen',
    symbols: {
        clear: 'sonnig',
        partly_cloudy: 'teils bewölkt',
        cloudy: 'bewölkt',
        fog: 'Nebel',
        drizzle: 'Nieselregen',
        rain: 'Regen',
        heavy_rain: 'starker Regen',
        sleet: 'Schneeregen',
        snow: 'Schnee',
        thunder: 'Gewitter',
    },
};
//# sourceMappingURL=homeApp.de.js.map